import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getSectorsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const sectorsItem = {
    label: t('sectors'),
    path: APP_URLS.dashboard.sectors.index.getPathWithQuery(),
  };
  const viewSectorItem = {
    label: t('view-sector'),
    path: APP_URLS.dashboard.sectors.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.sectors.index.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [dashboardHomeItem, { label: t('sectors') }],
    },
    {
      condition: APP_URLS.dashboard.sectors.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        sectorsItem,
        {
          label: t('create-new-sector'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sectors.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sectorsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sectors.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sectorsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sectors.sites.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sectorsItem,
        viewSectorItem,
        {
          label: t('linked-sites'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sectors.users.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sectorsItem,
        viewSectorItem,
        {
          label: t('members'),
        },
      ],
    },
  ];
}
